import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';

const AppointmentLayout = () => (
  <>
    <header>
      <div style={{ fontWeight: 'bold', fontSize: '20px', color: '#007bff' }}>ClinicPlus</div>
      <nav>
        <Link to="/">Home</Link>
        <a href="#facilities">Facilities</a>
        <a href="#services">Services</a>
        <a href="#contact">Contact Us</a>
        <Link to="/login" className="btn-blue" style={{ marginLeft: '20px' }}>Login</Link>
      </nav>
    </header>
    <main><Outlet /></main>
  </>
);

export default AppointmentLayout;